export type TagType = "恋爱" | "官宣" | "分手" | "约会";

export interface TrendingItem {
  rank: number;
  title: string;
  heat: string;
  category: string;
  isHot?: boolean;
}

export interface GossipCard {
  id: string;
  title: string;
  summary: string;
  tag: TagType;
  time: string;
  read: string;
  image: string;
  alt: string;
  source: string;
}

export interface HotPostItem {
  id: string;
  title: string;
  summary: string;
  image: string;
  alt: string;
  meta: string;
}

export interface TimelinePoint {
  date: string;
  title: string;
  detail: string;
}

export interface TimelineStory {
  id: string;
  kicker: string;
  title: string;
  image: string;
  alt: string;
  points: TimelinePoint[];
}

export interface ReviewItem {
  name: string;
  role: string;
  quote: string;
  avatar: string;
  star: number;
}

export interface FaqItem {
  q: string;
  a: string;
}

export const trendingItems: TrendingItem[] = [
  { rank: 1, title: "沈星野与林眠被拍同回公寓，疑似恋情曝光", heat: "185.6万", category: "约会实锤", isHot: true },
  { rank: 2, title: "影后苏蔓官宣分手，工作室声明措辞引热议", heat: "168.2万", category: "官宣分手", isHot: true },
  { rank: 3, title: "陈屿深夜与神秘女子共进晚餐被狗仔直击", heat: "142.7万", category: "约会实锤" },
  { rank: 4, title: "男团成员陆衍被爆与经纪人关系暧昧", heat: "129.4万", category: "恋情曝光" },
  { rank: 5, title: "赵清欢晒生日合照，网友扒出同款情侣手链", heat: "117.9万", category: "恋爱" },
  { rank: 6, title: "实力唱将方屿与素人女友低调领证", heat: "103.6万", category: "官宣" },
  { rank: 7, title: "演员程野与名模宋雨三年恋情走向终局", heat: "95.2万", category: "分手" },
  { rank: 8, title: "偶像歌手祁遇被拍到探班某剧组女演员", heat: "86.8万", category: "约会实锤" },
  { rank: 9, title: "老戏骨郝云情史被考古，圈内口碑两极", heat: "78.3万", category: "恋情曝光" },
  { rank: 10, title: "新生代小花白露与顶流合作后绯闻频上热搜", heat: "71.5万", category: "恋爱" },
];

export const gossipCards: GossipCard[] = [
  {
    id: "g1",
    title: "沈星野林眠深夜同回公寓，连续两晚被拍",
    summary: "狗仔连续两晚直击两人同回某高档公寓，虽未同框亲密，但同行接送细节被逐一记录，恋情猜测持续升温。",
    tag: "约会",
    time: "2小时前",
    read: "12.6万",
    source: "甜瓜直击",
    image: "https://readdy.ai/api/search-image?query=editorial%20magazine%20photo%20of%20a%20stylish%20young%20asian%20actor%20in%20oversized%20coat%20and%20cap%20walking%20at%20night%20toward%20a%20modern%20apartment%20building%2C%20candid%20street%20photography%2C%20moody%20warm%20street%20lighting%2C%20film%20grain%2C%20paparazzi%20aesthetic&width=800&height=600&seq=gossip-1&orientation=landscape",
    alt: "沈星野深夜返回公寓街拍画面，娱乐八卦恋情动态",
  },
  {
    id: "g2",
    title: "影后苏蔓发文官宣分手，和平结束六年感情",
    summary: "苏蔓以长文形式官宣与圈外男友和平分手，称彼此尊重各自人生方向，字里行间克制而体面，网友纷纷留言祝福。",
    tag: "分手",
    time: "5小时前",
    read: "18.3万",
    source: "工作室公告",
    image: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20an%20elegant%20asian%20film%20actress%20with%20soft%20serious%20expression%2C%20warm%20studio%20lighting%2C%20neutral%20background%2C%20high%20fashion%20magazine%20style%2C%20cinematic%20and%20emotional&width=800&height=600&seq=gossip-2&orientation=landscape",
    alt: "影后苏蔓官宣分手工作室声明，娱乐八卦分手动态",
  },
  {
    id: "g3",
    title: "陈屿深夜与神秘女子共进晚餐，互动亲密",
    summary: "有媒体拍到陈屿与一神秘女子在某私房菜馆共进晚餐，席间交谈甚欢，饭毕还亲自为对方披上外套，举止亲昵。",
    tag: "约会",
    time: "8小时前",
    read: "9.8万",
    source: "路透吃瓜",
    image: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20handsome%20asian%20celebrity%20man%20in%20smart%20casual%20shirt%20leaving%20an%20upscale%20restaurant%20at%20dusk%2C%20candid%20city%20street%20style%2C%20warm%20bokeh%20lights%2C%20gossip%20magazine%20mood&width=800&height=600&seq=gossip-3&orientation=landscape",
    alt: "陈屿深夜与女子用餐被拍，娱乐八卦约会动态",
  },
  {
    id: "g4",
    title: "男团成员陆衍被曝与经纪人关系不一般",
    summary: "知情人爆料陆衍与经纪人私下互动频繁，疑似超出工作范畴，团队暂未回应，粉丝与路人在线battle持续发酵。",
    tag: "恋爱",
    time: "11小时前",
    read: "7.6万",
    source: "瓜田情报",
    image: "https://readdy.ai/api/search-image?query=editorial%20portrait%20of%20a%20youthful%20asian%20male%20idol%20with%20soft%20hair%2C%20stylish%20jacket%2C%20backstage%20area%20with%20blurred%20stage%20lights%2C%20candid%20backstage%20photography%2C%20warm%20tones%2C%20celebrity%20magazine&width=800&height=600&seq=gossip-4&orientation=landscape",
    alt: "男团陆衍与经纪人绯闻爆料，娱乐八卦恋情曝光",
  },
  {
    id: "g5",
    title: "赵清欢生日照被扒出同款手链，疑隔空示爱",
    summary: "细心的网友在赵清欢生日照片中发现手部细节，被指与其绯闻对象戴着同款手链，评论区瞬间成为大型显微镜现场。",
    tag: "恋爱",
    time: "1天前",
    read: "15.1万",
    source: "显微镜小组",
    image: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20bright%20cheerful%20young%20asian%20woman%20holding%20a%20small%20birthday%20cake%20with%20candles%2C%20close%20up%20hands%20showing%20delicate%20bracelet%2C%20soft%20warm%20birthday%20light%2C%20magazine%20photography&width=800&height=600&seq=gossip-5&orientation=landscape",
    alt: "赵清欢生日照同款手链细节，娱乐八卦恋爱猜测",
  },
  {
    id: "g6",
    title: "实力唱将方屿与素人女友低调领证",
    summary: "方屿通过音乐作品隐晦官宣结婚消息，随后经纪团队证实其已领证，圈内好友纷纷送来祝福，网友直呼被甜到。",
    tag: "官宣",
    time: "1天前",
    read: "21.4万",
    source: "甜瓜直击",
    image: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20an%20asian%20male%20singer%20holding%20a%20guitar%20on%20stage%20under%20warm%20spotlights%2C%20joyful%20smile%2C%20confetti%20in%20air%2C%20live%20concert%20magazine%20photography%2C%20warm%20cinematic%20tones&width=800&height=600&seq=gossip-6&orientation=landscape",
    alt: "方屿官宣结婚领证，娱乐八卦官宣动态",
  },
];

export const hotPosts: HotPostItem[] = [
  {
    id: "h1",
    title: "一段被反复追问的六年：苏蔓与前任的分手全解析",
    summary: "从高调公开到体面收场，梳理苏蔓六年感情的时间线，复盘网友关注的每一个节点与双方从未明说的态度。",
    image: "https://readdy.ai/api/search-image?query=editorial%20cinematic%20photo%20of%20an%20asian%20actress%20silhouette%20looking%20out%20a%20large%20window%20in%20soft%20morning%20light%2C%20contemplative%20mood%2C%20warm%20neutral%20tones%2C%20high%20end%20magazine%20feature%20story&width=900&height=600&seq=hot-1&orientation=landscape",
    alt: "苏蔓分手始末深度解析专题文章",
    meta: "深度吃瓜 · 阅读 22.3万",
  },
  {
    id: "h2",
    title: "显微镜女孩的胜利：那些被网友扒出的恋爱铁证",
    summary: "同款单品、同城定位、卡点发文……盘点今年被网友循着蛛丝马迹实锤的几段恋情，看当代吃瓜学如何炼成。",
    image: "https://readdy.ai/api/search-image?query=editorial%20flat%20lay%20photography%20of%20two%20matching%20bracelets%2C%20concert%20tickets%2C%20airport%20boarding%20passes%20and%20a%20phone%20with%20social%20app%20on%20a%20warm%20paper%20background%2C%20detective%20investigation%20theme%2C%20soft%20lighting&width=900&height=600&seq=hot-2&orientation=landscape",
    alt: "网友扒明星恋爱铁证合集专题",
    meta: "盘点向 · 阅读 18.9万",
  },
  {
    id: "h3",
    title: "官宣文案学：明星们体面分手的文案都在说什么",
    summary: "从苏蔓到程野，拆解明星分手文案背后的措辞逻辑，看懂什么是真正的体面，也看懂工作室公关的层层深意。",
    image: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20a%20journalist%20notebook%2C%20fountain%20pen%2C%20and%20glasses%20on%20a%20desk%20with%20soft%20window%20light%2C%20warm%20writing%20room%20atmosphere%2C%20minimalist%20editorial%20style&width=900&height=600&seq=hot-3&orientation=landscape",
    alt: "明星官宣分手文案深度解读",
    meta: "深度吃瓜 · 阅读 13.5万",
  },
  {
    id: "h4",
    title: "恋爱脑还是保护私生活？明星谈恋爱的公开尺度",
    summary: "有人高调示爱有人藏到结婚，聊聊明星恋情公开的黄金分寸感，以及粉丝与路人视角的相爱相杀。",
    image: "https://readdy.ai/api/search-image?query=editorial%20photo%20of%20two%20silhouetted%20couples%20walking%20apart%20in%20opposite%20directions%20at%20golden%20hour%20with%20warm%20sunlight%2C%20cinematic%20emotional%20mood%2C%20high%20contrast%20artistic&width=900&height=600&seq=hot-4&orientation=landscape",
    alt: "明星恋情公开尺度讨论专题",
    meta: "观点向 · 阅读 11.2万",
  },
];

export const timelineStory: TimelineStory = {
  id: "timeline-1",
  kicker: "绯闻全记录",
  title: "从荧幕情侣到各奔东西：程野与宋雨的三年全记录",
  image: "https://readdy.ai/api/search-image?query=editorial%20wide%20cinematic%20photo%20of%20an%20asian%20actor%20and%20model%20walking%20together%20on%20a%20red%20carpet%20from%20behind%2C%20golden%20stage%20lights%2C%20elegant%20gala%20atmosphere%2C%20magazine%20cover%20story%20mood&width=1200&height=700&seq=timeline-cover&orientation=landscape",
  alt: "程野与宋雨三年恋情时间线封面图",
  points: [
    { date: "三年前 · 初识", title: "片场擦出火花，绯闻首度传出", detail: "两人因合作年代剧结缘，片场互动花絮流出后，关于恋情的猜测便未曾停歇，但双方均未正面回应。" },
    { date: "两年前 · 公开", title: "红毯同框，正式官宣恋情", detail: "在某电影节红毯上大方牵手亮相，随后微博卡点互表心意，正式承认恋情，收获大批祝福与关注。" },
    { date: "半年前 · 端倪", title: "互动减少，网友察觉异样", detail: "生日不再卡点、重要节点缺席，种种细节被网友捕捉，分手传闻开始在小范围内悄然发酵。" },
    { date: "近日 · 落幕", title: "分别发文，宣布和平分手", detail: "两人先后发文宣布结束三年恋情，措辞克制平和，表示将回归朋友关系，祝福彼此安好。" },
  ],
};

export const reviews: ReviewItem[] = [
  { name: "一颗甜瓜", role: "资深吃瓜网友", quote: "这里的瓜不只是搬运，每条都会把来龙去脉和时间线讲清楚，看完整段瓜再也不用自己去翻几十个帖子了。", avatar: "https://readdy.ai/api/search-image?query=minimalist%20flat%20avatar%20illustration%20of%20a%20young%20asian%20woman%20with%20short%20hair%20smiling%2C%20warm%20melon%20red%20and%20cream%20color%20palette%2C%20soft%20rounded%20style&width=200&height=200&seq=avatar-1&orientation=squarish", star: 5 },
  { name: "熬夜冠军", role: "八卦区常客", quote: "热点更新真的快，热搜榜一出我就来这儿吃完整瓜，还有深度复盘能补课，节奏刚刚好。", avatar: "https://readdy.ai/api/search-image?query=minimalist%20flat%20avatar%20illustration%20of%20a%20young%20asian%20man%20wearing%20glasses%20and%20hoodie%2C%20warm%20tones%2C%20soft%20rounded%20style&width=200&height=200&seq=avatar-2&orientation=squarish", star: 5 },
  { name: "吃瓜小分队", role: "娱乐资讯爱好者", quote: "最喜欢那种把一段绯闻从头到尾捋清楚的盘点，看得特别过瘾，页面也清爽不花哨。", avatar: "https://readdy.ai/api/search-image?query=minimalist%20flat%20avatar%20illustration%20of%20two%20friendly%20young%20friends%2C%20warm%20melon%20and%20gold%20palette%2C%20soft%20rounded%20style&width=200&height=200&seq=avatar-3&orientation=squarish", star: 5 },
];

export const faqItems: FaqItem[] = [
  { q: "绯闻瓜田的内容是从哪里来的？", a: "绯闻瓜田整合公开报道、工作室声明、媒体直击与网友公开讨论等信息，逐一核实来源后以时间线方式呈现，力求讲清一段绯闻的完整来龙去脉，而非简单转发未经证实的只言片语。" },
  { q: "为什么有些瓜会在第二天被删除或更新？", a: "娱乐圈动态变化极快，当事方可能随时发声澄清或提供新证据。我们会在核实到新信息后第一时间更新旧文，若原内容被证实不实，也会及时修正并标注，确保读者看到的始终是较接近事实的版本。" },
  { q: "绯闻瓜田是否只报道负面分手或出轨内容？", a: "并非如此。我们关注的是一段公开情感的完整故事，既包括恋爱与官宣的甜蜜瞬间，也包括约会实锤和体面分手，报道尺度始终基于公开事实，不编造细节、不引导网络暴力。" },
  { q: "看到喜欢的明星被说分手会很难过，你们如何把关尺度？", a: "我们理解粉丝的立场与情绪。所有内容均以当事方公开表态和可核实事实为准，避免主观臆测与情绪化表达，同时保留不同视角，把判断留给读者自己。" },
  { q: "可以投稿或提供爆料线索吗？", a: "当然可以。你可以在页面底部通过吃瓜早报订阅或评论区留下线索，我们会在核实信息来源后跟进整理，感谢每一位瓜田小伙伴的热心与信任。" },
];

export const brandStats = [
  { value: "1280+", label: "累计深度瓜料" },
  { value: "56", label: "情感专题梳理" },
  { value: "97.3%", label: "来源核实率" },
  { value: "240万+", label: "月阅读人次" },
];